import { styled } from '@goodfynd/theme';

export const StyledChart = styled('section', {
  minWidth: '100%',
});

export const StyledProductSquare = styled('div', {
  borderRadius: 2,
  height: 12,
  marginRight: 8,
  position: 'relative',
  width: 12,
});
